// extracted by mini-css-extract-plugin
module.exports = {"PrivacyPolicy":"PrivacyPolicy_PrivacyPolicy__1CsRg"};